import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f9e81e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-detail-wrapper" }
const _hoisted_2 = { class: "layout-inner -top-and-bottom" }
const _hoisted_3 = { class: "team-detail-content" }
const _hoisted_4 = { class: "return" }
const _hoisted_5 = { class: "nav-tabs" }
const _hoisted_6 = {
  class: "nav-tabs-list",
  role: "tablist"
}
const _hoisted_7 = {
  class: "item",
  role: "presentation"
}
const _hoisted_8 = ["aria-selected"]
const _hoisted_9 = {
  class: "item",
  role: "presentation"
}
const _hoisted_10 = ["aria-selected"]
const _hoisted_11 = ["aria-hidden"]
const _hoisted_12 = { class: "inner" }
const _hoisted_13 = ["aria-hidden"]
const _hoisted_14 = { class: "inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_TeamInformation = _resolveComponent("TeamInformation")!
  const _component_TeamPlayer = _resolveComponent("TeamPlayer")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              class: "global-return-link"
            }, "戻る")
          ]),
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "tab",
                  "aria-controls": "team",
                  "aria-selected": _ctx.tab.id === 'team' ? 'true' : 'false',
                  role: "tab",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickTab && _ctx.onClickTab(...args)))
                }, "チーム情報", 8, _hoisted_8)
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "tab",
                  "aria-controls": "player",
                  "aria-selected": _ctx.tab.id === 'player' ? 'true' : 'false',
                  role: "tab",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickTab && _ctx.onClickTab(...args)))
                }, "所属選手", 8, _hoisted_10)
              ])
            ])
          ]),
          _createElementVNode("div", {
            id: "team",
            class: "panel-content",
            "aria-hidden": _ctx.tab.id !== 'team',
            role: "tabpanel"
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_TeamInformation, {
                teamData: _ctx.team.data
              }, null, 8, ["teamData"])
            ])
          ], 8, _hoisted_11),
          _createElementVNode("div", {
            id: "player",
            class: "panel-content",
            "aria-hidden": _ctx.tab.id !== 'player',
            role: "tabpanel"
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_TeamPlayer, {
                teamPlayers: _ctx.team.players
              }, null, 8, ["teamPlayers"])
            ])
          ], 8, _hoisted_13)
        ])
      ])
    ]),
    (_ctx.accountDialogLeave.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.accountDialogLeave,
          onCloseDialog: _ctx.closeAccountDialogLeave,
          onOnConfirm: _ctx.onConfirmAccountDialogLaeve
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}